import { io } from "socket.io-client";
import CONSTANTS from "src/components/services/api";

export const socket = io(`${CONSTANTS.CHAT_BASE}`, {
    transports: ["websocket"],
    reconnectionAttempts: 5,
    timeout: 5000,
  });